import { ReactNode } from "react";
import { ChurchLogo } from "src/core/church/ChurchImages";

interface Props {
    img?: boolean;
    text?: string;
    subtitle?: ReactNode;
}

export const LoadingScreen = ({ img, text, subtitle }: Props) => (
    <div role="status" className="bg-base-200 flex justify-center items-center h-screen">
        <div>
            {img && <ChurchLogo className="dark:invert mx-auto h-32" />}

            <div className="text-center w-full h-10">
                <span className="loading loading-spinner" />
            </div>

            {text && (
                <div className="text-center mt-4">
                    <span>{text}</span>
                </div>
            )}

            {subtitle && <div className="text-center mt-2 text-sm opacity-75">{subtitle}</div>}

            <span className="sr-only">{text}</span>
        </div>
    </div>
);
